import * as React from 'react'
import injectSheet from 'react-jss'
import Input from 'material-ui-next/Input'
import FormControl from 'material-ui-next/Form/FormControl'
import InputLabel from 'material-ui-next/Input/InputLabel'
import FormHelperText from 'material-ui-next/Form/FormHelperText'

const styles = {
    colorBlack: {
        color: 'black',
    }
}

interface Props {
    readonly locked: boolean
    readonly value?: string | number
    readonly onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    readonly label?: string
    readonly className: string
    readonly fullWidth?: boolean
    readonly formHelperText?: string
    readonly error?: boolean
}

export const EditableTextField =
    injectSheet<Props>(styles)(
        ({classes, locked, onChange, value, label, className, fullWidth, formHelperText, error}) => (
            <FormControl
                className={className}
                fullWidth={fullWidth}
                error={error}
            >
                <InputLabel>
                    {label}
                </InputLabel>
                <Input
                    classes={{disabled: classes.colorBlack}}
                    disabled={locked}
                    disableUnderline={locked}
                    value={value}
                    onChange={onChange}
                />
                <FormHelperText>
                    {formHelperText}
                </FormHelperText>
            </FormControl>

        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/EditableTextField.tsx